import { VariantClass } from './variant-class';

export interface VariantFamily {
    id: number;
    description: string;
    value: string;
    variantClassId: number;
    variantClass: VariantClass;
}
